import { SummarizationNamespaces, queryKeys } from '@/app/utils/constants';
import { QueryKey } from '@tanstack/react-query';

export const getModelDetailsQueryKey = (
  summaryType: SummarizationNamespaces,
  id: string,
): QueryKey => {
  switch (summaryType) {
    case SummarizationNamespaces.BID:
      return [queryKeys.BID_DETAILS, id];
    case SummarizationNamespaces.TENDER_PACKAGE:
      return [queryKeys.TENDER_PACKAGE_DETAILS, id];
    case SummarizationNamespaces.CONTRACT:
      return [queryKeys.CONTRACT_DETAILS, id];
    case SummarizationNamespaces.SUPPLEMENT:
      return [queryKeys.SUPPLEMENT_DETAILS, id];
    case SummarizationNamespaces.EARLY_PHASE_ASSESSMENT:
      return [queryKeys.EARLY_PHASE_ASSESSMENTS_DETAILS, id];
    default:
      console.warn(`${summaryType}: Model Details Query key not found`);
      return [];
  }
};
